import React, { PropsWithChildren, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './Details.module.scss';
import Icon from '../../Atoms/Icon/Icon';
import { document } from '../../../js/globals';

export interface DetailsProps {
  children?: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
  disableToggle?: boolean;
}

export const Details: React.FC<DetailsProps> & {
  Content: typeof Content;
  Summary: typeof Summary;
} = ({ children, className, defaultOpen, disableToggle }) => {
  const refDetails = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    if (!disableToggle) {
      return undefined;
    }

    const handleClick = (e: MouseEvent) => {
      if (disableToggle && refDetails.current?.contains(e.target as Node)) {
        e.preventDefault();
      }
    };

    document?.addEventListener('click', handleClick, true);
    return () => document?.removeEventListener('click', handleClick, true);
  }, [disableToggle]);

  return (
    <details
      ref={refDetails}
      className={classNames(className, styles.Details)}
      open={defaultOpen}
    >
      {children}
    </details>
  );
};

const Content: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;
const Summary: React.FC<PropsWithChildren> = ({ children }) => (
  <summary>
    {children}
    <Icon
      className={styles.Details__icon_open}
      name="fa-plus"
    />
    <Icon
      className={styles.Details__icon_close}
      name="fa-minus"
    />
  </summary>
);

Details.Summary = Summary;
Details.Content = Content;

export default Details;
